import { jsx as _jsx } from "react/jsx-runtime";
import { isEmptyArray } from '@vista/omnichannel-components-domain';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { DropdownField } from '../../../../subcomponents/form/field/dropdown/dropdown-field';
import { TicketRedemptionCodeFormActionType as ActionType } from '../../ticket-redemption-code-form/types/action-type';
import { TicketRedemptionCodeFormContextInstance } from '../../ticket-redemption-code-form/types/context';
import { getDropdownOptionsForTypes } from '../../ticket-redemption-code-form/utils/get-dropdown-options-for-types';
import { showType as showTypeUtil } from '../../ticket-redemption-code-form/utils/show-type';
import { useResetField } from '../utils/use-reset-field';
export const TicketRedemptionCodeFormFieldType = observer(props => {
    const { skeleton, fieldKey } = props;
    const { formData, codeTypes, loading, validationConfig, onChange, config, dispatch } = useContext(TicketRedemptionCodeFormContextInstance);
    const showType = showTypeUtil(formData, config.validation, codeTypes);
    useResetField(props, showType);
    if (!showType || isEmptyArray(codeTypes))
        return null;
    if (loading)
        return skeleton;
    return (_jsx(DropdownField, Object.assign({}, props, { value: formData.typeId, validationConfig: validationConfig.typeId, options: getDropdownOptionsForTypes(codeTypes), enableSearch: config.enableSearch, onChangeValue: (newValue) => {
            onChange(fieldKey, newValue);
            dispatch({ type: ActionType.SetTypeHasBeenManuallySet });
        } })));
});
TicketRedemptionCodeFormFieldType.displayName = 'TicketRedemptionCodeFormFieldType';
